import { lazy } from 'react';

const AdminLayout = lazy(() => import('../layouts/AdminLayout'));
const AdminDashboard = lazy(() => import('../pages/Admin/Dashboard'));
const UsersList = lazy(() => import('../pages/Admin/UsersList'));
const UserDetail = lazy(() => import('../pages/Admin/UserDetail'));
const Directory = lazy(() => import('../pages/Admin/Directory'));

const adminRoutes = {
  path: 'admin',
  element: <AdminLayout />,
  children: [
    {
      index: true,
      element: <AdminDashboard />
    },
    {
      path: 'users',
      element: <UsersList />
    },
    {
      path: 'users/:userId',
      element: <UserDetail />
    },
    {
      path: 'directory',
      element: <Directory />
    }
  ]
};

export default adminRoutes;